const getters = {
    audio: state => state.audioData.audio,
    pronunciation: state => state.audioData.pronunciation,
    getThesaurusHeadword: state => state.thesaurusHeadword,
    getThesaurus: state => state.filteredThesaurus,
    getOriginalThesaurusLength: state => state.thesaurus.length,
    getFirst10Synonyms: state => {
        const words = state.thesaurus.map(synonym => synonym.word.headword);
        return words.length < 10 ? words : words.slice(0, 11);
    },
    getThesaurusLength: state => state.filteredThesaurus.length,
    getActiveFiltersAmount: state => {
        return Object.keys(state.filters)
            .map(filter => state.filters[filter].active)
            .flat(1).length;
    },
    getPosActiveFilters: state => state.filters.pos.active,
    getCategoryActiveFilters: state => state.filters.category.active,
    getSortedAZThesaurus: state => state.sortedAZThesaurus,
    isThesaurusLoaded: state => state.isThesaurusLoaded,
    isMobileFilterPanelOpened: state => state.isMobileFilterPanelOpened,
    getFiltersObj: state => state.filters,
    getSynonymStudies: state => state.study,
    getCopiedSynonym: state => state.copiedSynonym,
    isCopyToastVisible: state => state.isCopyToastVisible
};

export default getters;



// WEBPACK FOOTER //
// ./src/store/ThesaurusFilter/getters.js